module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Black-Beauty.62a9698.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Black-Beauty.jpg
// module id = qZNB
// module chunks = 0